export const projects = [
  {
    title: 'Forest Park Cabin',
    meta: 'Roof windows · 6 units',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-proj-woodland.webp',
  },
  {
    title: 'Laurelhurst Craftsman',
    meta: 'Full replacement · 22 units',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-proj-traditional.webp',
  },
  {
    title: 'West Hills Residence',
    meta: 'Lift & slide · 4 panels',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-proj-panoramic.webp',
  },
  {
    title: 'Sellwood Loft',
    meta: 'Picture windows · 3 units',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-proj-corner.webp',
  },
];

export const estimateCopy = {
  eyebrow: 'Free estimate',
  title: 'Let\u2019s frame your next view.',
  text: 'Tell us a little about your home. A designer will reply within one business day with next steps and a visit time.',
  image: 'https://public.readdy.ai/ai/img_res/sandbox/52cdcd16a5556f6302fcb5f05fda2c37/d504a9d8-43f0-415a-838b-e8ea414aedab_nl-estimate.webp',
};

export const footerCopy = {
  address: '2140 NW Thurman St, Portland, OR 97210',
  phone: '(503) 555-0148',
  email: 'hello@northlightwindows.com',
  descriptor: 'Residential windows — replacement & installation',
  statement: 'Better windows, quietly installed — so the light, the trees and the seasons feel like part of home.',
  columns: [
    { title: 'Windows', links: [{ label: 'Solutions', href: '#windows' }, { label: 'Natural light', href: '#comfort' }, { label: 'Projects', href: '#projects' }] },
    { title: 'Company', links: [{ label: 'About', href: '#about' }, { label: 'Our process', href: '#process' }, { label: 'FAQ', href: '#faq' }] },
  ],
};